import type { SVGProps } from 'react';
const DawnFlagEG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-EG_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-EG_svg__a)">
      <path fill="#E41D33" d="M0 5.333h22V0H0z" />
      <path fill="#262626" d="M0 16h22v-5.333H0z" />
      <path
        fill="#F4B32E"
        fillOpacity={0.25}
        d="M8.38 7.067c0-.369.3-.667.668-.667h.173c.127 0 .243.072.299.186l.432.88S10.528 6.4 11 6.4c.524 0 1.047 1.067 1.047 1.067l.433-.88a.33.33 0 0 1 .299-.187h.173c.368 0 .667.298.667.667v1.275a.667.667 0 0 1-1.041.551l-.53-.36h-.524v.543c0 .29-.235.524-.524.524"
      />
      <path
        fill="#C6A846"
        d="m9.491 8.04-.443-.903v1.205zm.461.493-.53.36a.667.667 0 0 1-1.041-.551V7.067c0-.369.298-.667.667-.667h.173c.127 0 .243.072.299.186l.432.88s.184-.34.43-.637c.188-.228.413-.43.618-.43.222 0 .444.193.626.413.248.3.422.655.422.655l.432-.88a.33.33 0 0 1 .299-.187h.173c.368 0 .667.298.667.667v1.275a.667.667 0 0 1-1.041.551l-.53-.36h-.524v.543a.524.524 0 1 1-1.048 0v-.543zm2.557-.493.443.302V7.137zM11.5 7.867h-1.007l.045-.083.003-.006.015-.027a4 4 0 0 1 .273-.414q.099-.13.181-.21.078.075.172.202a3 3 0 0 1 .251.402l.013.025.003.005z"
      />
    </g>
  </svg>
);
export default DawnFlagEG;
